<template>
  <div>
    <ld-header>员工管理</ld-header>

    <van-search
      placeholder="请输入搜索关键词"
      shape="round"
      v-model="value"
      @cancel="query"
    />

    <div class="wrapper">
      <mescroll-vue
        ref="mescroll"
        @init="mescrollInit"
        :up="{ use: true, callback: onRefresh }"
      >
        <van-row
          v-for="(info,index) in filteredList "
          :key="index"
          class="emp-item"
          type="flex"
          align="center"
          @click="edit(info)"
        >

          <van-col :span="6">
            <div class="emp-item__title van-ellipsis">
              {{ info | getName }}
            </div>
            <div v-if="info.idNumber">
              {{ $t('D004','身份证') }}
            </div>
            <div v-else-if="info.passport">
              {{ $t('D005','护照') }}
            </div>
            <div v-else-if="info.otherNumber">
              其它证件
            </div>
            <div v-else>
              未添加证件号码
            </div>
            <div>
              部门
            </div>
          </van-col>
          <van-col :span="16">
            <div class="emp-item__title">
              {{ info.phoneNumber }}
            </div>
            <div class="van-ellipsis">
              <span v-if="info.idNumber">{{ info.idNumber }}</span>
              <span v-else-if="info.passport">{{ info.passport }}</span>
              <span v-else-if="info.otherNumber">{{ info.otherNumber }}</span>
            </div>
            <div class="van-ellipsis">
              {{ info.deptName }}
            </div>
          </van-col>
          <van-col
            :span="2"
            @click.stop="deleteEmp(info)"
          >
            <van-icon
              size="18"
              name="delete"
            />
          </van-col>
        </van-row>
      </mescroll-vue>
    </div>

    <div
      class="add-btn linear-main2"
      @click="edit({})"
    >
      <van-icon
        color="#fff"
        name="plus"
        size="34"
      />
    </div>

  </div>
</template>

<script>
import { SwipeCell , Cell, Button, Search } from 'vant'
import MescrollVue from 'mescroll.js/mescroll.vue'
import { mapGetters } from 'vuex'
import { localget } from 'Utils/storage.js'

export default {
  name: 'EmpList',
  components: {
    [SwipeCell.name]:SwipeCell,
    [Cell.name]:Cell,
    [Button.name]:Button,
    [Search.name]:Search,
    MescrollVue
  },
  data () {
    return {
      show: false,
      lis:'',
      value: '',
      empListData: [],

    }
  },
  created(){
    console.log(this)
  },
  methods: {
    mescrollInit (mescroll) {
      this.mescroll = mescroll  // 如果this.mescroll对象没有使用到,则mescrollInit可以不用配置
    },
    onRefresh(page, mescroll) {
      this.query(page, mescroll)
    },
    async query (page) {
      try {
        if(this.lis == 0){
          let { data } = await this.$api['emp/empFindList']({
            queryStr: this.value,
          })
          let list = data.list || []

          if (list.length) {
            if (data.pageNum > 1) {
              this.empListData.push(...list)
            } else if (data.pageNum == 1) {
              this.empListData = list
            }
          }
          this.$nextTick(() => {
            this.mescroll.endSuccess(list.length, data.total)
          })
        }
        if(this.lis == 1){
          let { data } = await this.$api['emp/empFindList']({
            queryStr: this.value,
            count: page.size,
            pageNum: page.num
          })
          let list = data.list || []
          if (list.length) {
            if (data.pageNum > 1) {
              this.empListData.push(...list)
            } else if (data.pageNum == 1) {
              this.empListData = list
            }
          }
          this.$nextTick(() => {
            this.mescroll.endSuccess(list.length, data.total)
          })
        }
        if(this.lis == 2){
          let { data } = await this.$api['emp/empFindList']({
            queryStr: this.value,
            count: page.size,
            pageNum: page.num
          })
          let list = data.list || []
          if (list.length) {
            if (data.pageNum > 1) {
              this.empListData.push(...list)
            } else if (data.pageNum == 1) {
              this.empListData = list
            }
          }
          this.$nextTick(() => {
            this.mescroll.endSuccess(list.length, data.total)
          })
        }
      } catch(err) {
        this.mescroll && this.mescroll.endErr()
        throw err
      }
    },
    edit ({ empId = '' }) {
      const userInfo = localget('userInfo') || {};
      if (userInfo && userInfo.vipCorp && userInfo.vipCorp.bookStyle && userInfo.empInfo) {
        // 申请单模式用户端统一不能修改人员信息
        if (userInfo.vipCorp.bookStyle === 2) {
          this.$dialog({message: '不能修改人员信息'});
          return;
        }
        if (userInfo.vipCorp.bookStyle === 1 && userInfo.empInfo.xgygxx === 0) {
          this.$dialog({message: '不能修改人员信息'});
          return;
        }
      }

      this.$router.push({ path: `/userCenter/empEdit/${empId}` })
    },
    pullUpload (val) {
      console.log('val: ', val)
    },
    deleteEmp ({ empId }) {// 显示
      this.$dialog.confirm({
        message: '确定删除吗？'
      }).then(() => {
        this.$api['emp/vipEmpDel']({ id: empId }).then(() => {
          this.$dialog({
            message: '删除成功！'
          }).then(() => {
            this.query(this.value)
          })
        })
      })
    }
  },
  computed: {
    filteredList(){
      return this.empListData.filter((item)=>{
        var userInfolist = JSON.parse(localStorage.getItem('userInfo')).empInfo
        if(userInfolist.popElevel == 1){
          this.lis = 0
          return item.empName == userInfolist.empName
        }
        if(userInfolist.popElevel == 3){
          this.lis = 1
          return item.deptName == userInfolist.deptName
        }
        if(userInfolist.popElevel == 5){
          this.lis = 2
          return item.empName
        }
      })
    },
    ...mapGetters(['loginConfig']),
  },
  watch:{
    value(val){
      this.query(val)
    }
  }
}
</script>

<style lang="less" scoped>
.wrapper {
  height: calc(100vh - 96px);
  overflow: hidden;
  padding: 5px;
}
.emp-item {
  line-height: 20px;
  background-color: @color-background-white;
  border-radius: @border-radius-sm;
  margin-bottom: 5px;
  padding: 10px 16px;
  font-size: @font-size-12;
  color: @color-text-gray;

  .emp-item__title {
    font-size: @font-size-16;
    color: @color-text-black;
  }
}
  .add-btn {
    position: fixed;
    right: 20px;
    bottom: 60px;
    padding: 10px;
    border-radius: 50%;
    font-size: 0;
    box-shadow: 0px 13px 18px 0px
      rgba(201, 153, 94, 0.23);
  }
</style>

